/* remy-collection.js -- HAND-AUTHORED (theme-src/, HANDOFF §37, §38).
   Store-only: Load More for ANY paginated product grid -- the collection
   page (sections/main-collection.liquid) and the search page
   (sections/main-search.liquid). A section opts in with two hooks:
   [data-remy-grid] on the grid and [data-remy-load-more] +
   data-section-id on the next-page link. Nothing here is collection-specific;
   the file name is historical.

   Without JS, [data-remy-load-more] is a plain link to ?page=N+1. With JS it
   fetches that page's grid through the Section Rendering API
   (?page=N+1&section_id=<id>) and appends the cards, so the shopper stays on
   one page. Cards are de-duplicated by data-handle, so a collection that
   changes between fetches can never show a card twice. Any failure falls back
   to following the link.

   Deliberately NOT the static build's [data-load-more] hook: script.js's
   handler for that reveals pre-rendered hidden cards and would remove this
   button on sight (there are none). */
(function () {
  'use strict';

  function bind(btn) {
    btn.addEventListener('click', function (e) {
      // the grid in the SAME section as this button
      var scope = btn.closest('.shopify-section') || document;
      var grid = scope.querySelector('[data-remy-grid]');
      if (!grid || !window.fetch || !window.DOMParser) return;   // follow the link
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');

      var url = new URL(btn.href, window.location.href);
      url.searchParams.set('section_id', btn.getAttribute('data-section-id'));

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var seen = {};
          grid.querySelectorAll('.pcard[data-handle]').forEach(function (c) {
            seen[c.getAttribute('data-handle')] = true;
          });
          doc.querySelectorAll('[data-remy-grid] .pcard').forEach(function (c) {
            var h = c.getAttribute('data-handle');
            if (seen[h]) return;
            seen[h] = true;
            grid.appendChild(document.importNode(c, true));
          });

          var next = doc.querySelector('[data-remy-load-more]');
          if (next) {
            // the section response may carry section_id in its own next
            // link; strip it so the no-JS fallback stays a full page
            var nu = new URL(next.getAttribute('href'), window.location.href);
            nu.searchParams.delete('section_id');
            btn.href = nu.pathname + nu.search;
            var c = btn.querySelector('.loadmore__count');
            var nc = next.querySelector('.loadmore__count');
            if (c && nc) c.textContent = nc.textContent;
            btn.removeAttribute('aria-busy');
          } else {
            var wrap = btn.closest('.loadmore-wrap');
            (wrap || btn).parentNode.removeChild(wrap || btn);
          }
        })
        .catch(function () {
          window.location.href = btn.href;
        });
    });
  }

  document.querySelectorAll('[data-remy-load-more]').forEach(bind);

  /* Sort by (collection toolbar). A native <select>: on change, set ?sort_by
     on the CURRENT url (every other param kept, ?page dropped so the shopper
     lands on page 1 of the new order). Without JS the <noscript> Apply
     button submits the same GET form. */
  document.querySelectorAll('[data-remy-sort] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
}());
